import ScrollDownItem from '@/core/components/ScrollDownItem/ScrollDownItem';

export default ScrollDownItem;
